module.exports = __webpack_public_path__ + "static/10-yard-dumpster-banner-a2439d36ead43a2dec9ce5adabe1d6ae.jpg";